import { createRouter, createWebHashHistory } from "vue-router";
import axios from "axios";
import { setUser, clearUser } from "../composables/useAuth";

const routes = [
  {
    path: "/",
    name: "Home",
    meta: { title: "Stock Opname", fullscreen: true },
    component: () => import("../views/Scan/Home.vue"),
  },
  {
    path: "/gudang",
    name: "Gudang List",
    // khusus desktop (manajemen gudang)
    meta: { title: "Daftar Gudang", fullscreen: true },
    component: () => import("../views/Scan/Gudang-List.vue"),
  },
  {
    // khusus desktop: monitor progress 1 sesi SO (grid / table per gudang)
    path: "/sesi/:id",
    name: "Sesi Detail",
    meta: { title: "Detail Stock Opname", fullscreen: true },
    component: () => import("../views/Scan/Sesi-Detail.vue"),
  },
  {
    // khusus desktop: detail hasil 1 gudang (selisih stok sistem vs hasil SO)
    path: "/sesi/:id/gudang/:idWarehouse",
    name: "Gudang Detail",
    meta: { title: "Detail Gudang", fullscreen: true },
    component: () => import("../views/Scan/Gudang-Detail.vue"),
  },
  {
    // 1 workspace: detail/scan/input jadi sub-view internal (data tak hilang
    // saat pindah). id sesi & gudang opsional (untuk Save ke backend).
    path: "/opname/:idSession?/:idWarehouse?",
    name: "Opname Workspace",
    meta: { title: "Stock Opname", fullscreen: true },
    component: () => import("../views/Scan/Opname-Workspace.vue"),
  },
  {
    path: "/login",
    name: "Login",
    meta: { title: "Login", noAuth: true, fullscreen: true },
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// guard ala drkevin-scan: token JWT (login terpisah, akun sama di scan-backend)
// divalidasi ke /user/user_data tiap navigasi; tanpa allowed_paths/role check
// karena isinya path drkevin-scan, bukan path aplikasi ini
router.beforeEach(async (to, from, next) => {
  let token = localStorage.getItem(process.env.VUE_APP_TOKEN_NAME);
  if (to.meta.noAuth) {
    next();
  } else if (token === null) {
    next("/login");
  } else {
    try {
      let resp = await axios.post(
        `${process.env.VUE_APP_BASE_URL}/user/user_data`,
        {
          token: token,
          route: {
            name: to.name,
            path: to.fullPath,
          },
        },
      );
      to.meta.user = resp.data;
      setUser(resp.data);
      next();
    } catch (error) {
      clearUser();
      localStorage.removeItem(process.env.VUE_APP_TOKEN_NAME);
      let redirect_url = encodeURIComponent(to.fullPath);
      next(`/login?redirect_url=${redirect_url}`);
    }
  }
});

export default router;
